import './SociallyActivitiesPage.css';
import Header from '../Header/Header.js';
import Footer from '../Footer/Footer.js';

const agreementFiles = [
  '1. Соглашение Главное управление МЧС России по Самарской области и Самарское областное отделение ВДПО.pdf',
  '2. Соглашение о взаимодействии ВДПО - ГКУ Самарской области Центра по делам ГО, ПБ и ЧС от 12.09.2023.pdf',
  '3. Соглашение о сотрудничестве Движение первых и Самарское областное отделение ВДПО.pdf',
  '4. Соглашение о сотрудничестве с ВСКС.pdf',
  '5. Соглашение Самарское областное отделение ВДПО и Добровольная пожарная команда Самарской области.pdf',
  '6. Соглашение о сотрудничестве с Общественной организацией Совет ветеранов.pdf',
];

const activitySections = [
  {
    title: 'Добровольные пожарные команды',
    text: 'В настоящее время на территории Самарской области от ВДПО функционируют 17 добровольных пожарных команд: г. Самара, г. Тольятти, г. Похвистнево, в Кинельском, Красноярском и Кинель-Черкасском районах. Общее количество добровольцев: 96 человек.',
  },
  {
    title: 'Дружины юных пожарных',
    text: 'При поддержке Самарского областного отделения ВДПО возрождается работа Дружин юных пожарных на территории всей Самарской области. На сегодняшний день функционируют 86 дружин юных пожарных (1119 учащихся).',
  },
  {
    title: 'Пожарно-прикладной спорт',
    text: 'Самарское областное отделение ВДПО активно поддерживает и финансирует Федерацию пожарно-спасательного спорта Самарской области и детский пожарно-спасательный спорт.',
  },
  {
    title: 'Пропаганда пожарной безопасности',
    text: 'Совместно с Главным управлением МЧС России по Самарской области и Министерством образования и науки Самарской области в соответствии с планом мероприятий на регулярной основе проводятся конкурсы «Неопалимая Купина», «Мир в наших руках», «Человек доброй воли», «Лучшая дружина юных пожарных России», проводятся городские и областные соревнования среди учащихся школ («Школа безопасности», «Спасрезерв», «Школа пожарных наук ВДПО»). Открытые уроки и занятия на тему пожарной безопасности в образовательных учреждениях Самарской области проходят по утвержденному графику. Самарское областное отделение ВДПО активно участвует в благотворительной деятельности.',
  },
];

const activityPhotos = [
  {
    src: '/images/social-activity-children.jpg',
    alt: 'Участники социально-ориентированного мероприятия ВДПО с детьми',
  },
  {
    src: '/images/social-activity-firefighter.jpg',
    alt: 'Пожарный добровольного отряда рядом с пожарной техникой',
  },
  {
    src: '/images/дети у машины.jpg',
    alt: 'Дети у пожарной машины на профилактическом мероприятии',
  },
  {
    src: '/images/учения1.jpg',
    alt: 'Практическое занятие по пожарной безопасности',
  },
  {
    src: '/images/IMG_20240207_100553.jpg',
    alt: 'Пожарный расчет на дежурстве',
  },
  {
    src: '/images/Арго рукав.jpg',
    alt: 'Пожарный рукав и оборудование для практических работ',
  },
  {
    src: '/images/Заря 08 (1).jpeg',
    alt: 'Пожарное оборудование на профильном объекте',
  },
  {
    src: '/images/газпром (2).jpg',
    alt: 'Пожарная техника на промышленной площадке',
  },
];

function SociallyActivitiesPage() {
  return (
    <>
      <Header />
      <main className="content">
        <section className="sociallyActivities">
          <div className="sociallyActivities__hero">
            <h2 className="sociallyActivities__title">
              Социально-ориентированная деятельность
            </h2>
            <p className="sociallyActivities__lead">
              Самарское областное отделение ВДПО развивает добровольчество,
              поддерживает юных пожарных, профильный спорт и профилактические
              мероприятия по пожарной безопасности.
            </p>
          </div>

          <section
            className="sociallyActivities__section"
            aria-labelledby="sociallyActivities-directions"
          >
            <div className="sociallyActivities__section-heading">
              <p className="sociallyActivities__section-kicker">Направления</p>
              <h3
                className="sociallyActivities__section-title"
                id="sociallyActivities-directions"
              >
                Социальная работа ВДПО в Самарской области
              </h3>
            </div>

            <div className="sociallyActivities__text-grid">
              {activitySections.map((section) => (
                <article
                  className="sociallyActivities__text-item"
                  key={section.title}
                >
                  <h4 className="sociallyActivities__text-title">
                    {section.title}
                  </h4>
                  <p className="sociallyActivities__text">{section.text}</p>
                </article>
              ))}
            </div>
          </section>

          <section
            className="sociallyActivities__section"
            aria-labelledby="sociallyActivities-agreements"
          >
            <div className="sociallyActivities__section-heading">
              <p className="sociallyActivities__section-kicker">Документы</p>
              <h3
                className="sociallyActivities__section-title"
                id="sociallyActivities-agreements"
              >
                Наши соглашения
              </h3>
            </div>

            <div className="sociallyActivities__list">
              {agreementFiles.map((fileName, index) => (
                <article className="sociallyActivities__card" key={fileName}>
                  <div className="sociallyActivities__card-content">
                    <p className="sociallyActivities__card-number">
                      Документ {index + 1}
                    </p>
                    <h4 className="sociallyActivities__card-title">
                      {fileName.replace('.pdf', '')}
                    </h4>
                  </div>
                  <a
                    href={`/images/vdpo_agreements/${encodeURIComponent(fileName)}`}
                    className="sociallyActivities__card-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Открыть файл
                  </a>
                </article>
              ))}
            </div>
          </section>

          <section
            className="sociallyActivities__section"
            aria-labelledby="sociallyActivities-gallery"
          >
            <div className="sociallyActivities__section-heading">
              <p className="sociallyActivities__section-kicker">Фотографии</p>
              <h3
                className="sociallyActivities__section-title"
                id="sociallyActivities-gallery"
              >
                Мероприятия, добровольцы и пожарная безопасность
              </h3>
            </div>

            <div className="sociallyActivities__gallery">
              {activityPhotos.map((photo) => (
                <figure className="sociallyActivities__photo" key={photo.src}>
                  <img
                    className="sociallyActivities__photo-image"
                    src={photo.src}
                    alt={photo.alt}
                    loading="lazy"
                  />
                </figure>
              ))}
            </div>
          </section>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default SociallyActivitiesPage;
